<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="targetRules"
    label='Target'
    data-track="target"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputProjectName extends Vue {
  targetRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Target is required'];
}
</script>
